<template>
  <section id="parallax" class="">
    <SmallHeart
      v-for="(heart, i) in hearts"
      :key="i"
      :hash="heart.image.private_hash"
      :artist="heart.artist"
      class="inline-block floatingheart"
      figstyles=" m-2 p-2 h-full w-full flex justify-center items-center fadeup"
      style="z-index:-1"
      :showName="false"
      :style="getRandomPosition(i)"
      v-in-viewport
    />

    <!-- <SmallHeart
      id="heart1"
      :hash="currentHash"
      :artist="currentArtist"
      class="inline-block floatingheart"
      figstyles=" m-2 p-2 h-full w-full flex justify-center items-center fadeup"
      style="z-index:-1"
      :showName="false"
      v-in-viewport
    /> -->
  </section>
</template>
<script>
import SmallHeart from "@/components/SmallHeart.vue";

import Axios from "axios";

export default {
  data() {
    return {
      index: 0,
      currentHash: "m61r079el1wsocs0",
      currentArtist: "",
      fading: false,
      parallaxURL:
        "https://api.caseyhouse.com/sendyourlove/items/hearts?fields=id,artist,anonymous,image.private_hash,image.width,image.height&sort=?&limit=4&filter[parallax][nempty]",
      parallaxHearts: [],
      hearts: [],
      xpositions: [ 0.25, 0.5, 0.75],
      ypositions: [ 0.25, 0.5, 0.85],
    };
  },
  components: {
    SmallHeart,
    //    Parallax
  },
  mounted() {
    this.shuffle(this.xpositions);
    this.shuffle(this.ypositions);

    this.xpositions.unshift(0);
    this.ypositions.unshift(0);

    Axios.get(this.parallaxURL).then(
      function(response) {
        this.hearts = response.data.data;
        setInterval(this.attachHeart, 5000);
      }.bind(this)

      // (response) => (this.parallaxHearts = response.data.data)
    );

    // setInterval(this.trackFade, 100);
  },
  update() {
    console.log("fading", this.fading);
  },
  methods: {
    getRandomPosition(i) {
      var x, y;
      // if (i == 0) {
        // x = 0;
        // y = 0;
      // } else {
        i = i % this.hearts.length;
        x = this.ypositions[i];
        y = this.xpositions[i];
      // }
      let hearttop = "top:calc(100vh * " + y + ");";
      let heartleft = "right:calc(100vw * " + x + ");";
      return hearttop + heartleft;
    },
    shuffle(a) {
      var j, x, i;
      for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
      }
      return a;
    },
    trackFade() {
      console.log("fadevar", this.fading);
    },
    attachHeart() {
      // console.log("attaching heart");
      var h = this.hearts[this.index];
      this.currentHash = h.image.private_hash;
      this.currentArtist = h.artist;
      // console.log("attachHeart",this.index, this.hearts.length);
      this.fading = true;
      this.index++;
      this.index = this.index % 3;
    },
  },
  computed: {
    pvalue() {
      return Math.random();
    },
  },
};
</script>

<style scoped>
.floatingheart {
  /* opacity: 0.5; */
}

/* .floatingheart:nth-of-type(1) {
  top: calc(100vh / 4);
  left: calc(100vw * 0.75);
}

.floatingheart:nth-of-type(2) {
  top: calc(100vh *0);
  left: calc(100vw * 0.5);
}

.floatingheart:nth-of-type(3) {
  top: calc(100vh * 0.75);
  left: calc(100vw * 0.25);
} */

/* Fading entrances  */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadein {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
}

@-webkit-keyframes fadeInUp {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.fadeup {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
}
</style>
